import { OperationVariables, ApolloQueryResult } from '@apollo/client';

import { EcpProfileResponse } from '../../../../graphql/ecp-locator/models';
import {
  AppointmentBannerResponse,
} from '../../../../graphql/ecp-locator/models/ecp-profile.models';

export interface IEcpLocatorProps {
  isLoading?: boolean;
  isError?: boolean;
  isFitted?: boolean;
  isLoggedIn?: boolean;
  hasExternalAddress: boolean;
  isResolved: boolean;
  refetchProfile: ((variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<EcpProfileResponse>>) | null;
  appointment?: AppointmentBannerResponse | null;
}

export enum EcpServices {
  buy = 'buy',
  fit = 'fit',
  cataract = 'cataract',
  cv = 'cv',
  aec = 'aec',
}

export enum BuySortTypes {
  offline = 'offline',
  online = 'online',
}
